import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export const GoalSummarySectionOverride = fr.metaOverride({ base: BaseOverride })
  .nameOverride(['title', 'subtitle'], {
    hidden: true,
  }, overrideReadOnly);
